import script from "./EstatisticasJogadorView.vue?vue&type=script&setup=true&lang=js"
export * from "./EstatisticasJogadorView.vue?vue&type=script&setup=true&lang=js"

import "./EstatisticasJogadorView.vue?vue&type=style&index=0&id=76c27c84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76c27c84"]])

export default __exports__